import moment from 'moment';

export function plusWeek(date: string, numberOfWeeks: number) {
  return moment(date).add(numberOfWeeks, 'week').toISOString();
}

export function minusWeek(date: string, numberOfWeeks: number) {
  return moment(date).subtract(numberOfWeeks, 'week').toISOString();
}

export function plusDayAtStartOfDay(date: string, numberOfDays: number) {
  return moment(date).startOf('days').add(numberOfDays, 'days').toISOString();
}

export function minusWeekAtStartOfIsoWeek(date: string, numberOfWeeks: number) {
  return moment(date).startOf('isoWeek').subtract(numberOfWeeks, 'week').toISOString();
}

export function minusWeekAtEndOfIsoWeek(date: string, numberOfWeeks: number) {
  return moment(date).endOf('isoWeek').subtract(numberOfWeeks, 'week').toISOString();
}

export function plusWeekAtStartOfIsoWeek(date: string, numberOfWeeks: number) {
  return moment(date).startOf('isoWeek').add(numberOfWeeks, 'week').toISOString();
}

export function plusWeekAtEndOfIsoWeek(date: string, numberOfWeeks: number) {
  return moment(date).endOf('isoWeek').add(numberOfWeeks, 'week').toISOString();
}

export function plusDays(date: Date, numberOfDays: number): Date {
  let day: Date = new Date(date.getTime());
  day.setDate(date.getDate() + numberOfDays);
  return day;
}

export function minusDays(date: Date, numberOfDays: number): Date {
  let day: Date = new Date(date.getTime());
  day.setDate(date.getDate() - numberOfDays);
  return day;
}

export function sameDay(d1: Date, d2: Date): boolean {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

export function combineDateAndTimeToFormat(date: string, time: string) {
  const dateParts = date.split('-');
  const timeParts = time.split(':');

  const year = parseInt(dateParts[0]);
  const month = parseInt(dateParts[1]) - 1; // Les mois en JavaScript commencent à 0
  const day = parseInt(dateParts[2]);
  const hours = parseInt(timeParts[0]);
  const minutes = parseInt(timeParts[1]);
  if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hours) || isNaN(minutes)) {
    return null;
  }
  const userDate = new Date(year, month, day, hours, minutes);

  return userDate.toISOString();
}
